var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3643_3435)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.3296 18.3408C34.2631 18.0436 34.1252 17.767 33.9278 17.5351C33.7304 17.3031 33.4795 17.1227 33.1968 17.0095L25.1999 13.8111L26.8546 2.77829C26.9153 2.38211 26.8475 1.9769 26.6611 1.62208C26.4747 1.26726 26.1795 0.981516 25.8188 0.806758C25.4581 0.631999 25.0508 0.577424 24.6569 0.651038C24.2629 0.724651 23.9028 0.922579 23.6296 1.21579L6.12957 19.9658C5.92156 20.1886 5.77098 20.4587 5.69089 20.7528C5.6108 21.0468 5.60361 21.356 5.66994 21.6535C5.73627 21.951 5.87412 22.2278 6.07156 22.46C6.26899 22.6922 6.52006 22.8728 6.80301 22.9861L14.7999 26.1845L13.1452 37.222C13.0845 37.6182 13.1523 38.0234 13.3387 38.3783C13.5251 38.7331 13.8203 39.0188 14.181 39.1936C14.5417 39.3683 14.9489 39.4229 15.3429 39.3493C15.7369 39.2757 16.0969 39.0778 16.3702 38.7845L33.8702 20.0345C34.0791 19.8111 34.2302 19.54 34.3103 19.2447C34.3903 18.9495 34.397 18.6392 34.3296 18.3408ZM17.7499 31.8049L18.7296 25.2783C18.7922 24.8606 18.7119 24.434 18.5018 24.0676C18.2916 23.7012 17.9639 23.4164 17.5718 23.2595L10.7405 20.5267L22.2499 8.19548L21.2702 14.722C21.2076 15.1398 21.2879 15.5664 21.498 15.9328C21.7081 16.2992 22.0358 16.5839 22.428 16.7408L29.2593 19.4736L17.7499 31.8049Z",
    fill: "#9DADC9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3643_3435"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightning);
export default __webpack_public_path__ + "static/media/Lightning.193a4ed2afe8a4f3775f8ea7cbc4a79f.svg";
export { ForwardRef as ReactComponent };